export default {
	tenantId: "madera_poc",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "madera--poc"
	}
}
